import React from "react";
import PDFViewer from "./PDFViewer";
import moment from "moment";
import { VersionAutoCompleteInput } from "../../../../components/form-group";

const DocumentView: React.FunctionComponent<{
  currentFile: any;
  reload?: () => void;
  onEdit?: () => void;
  versions?: any[];
  changeDocument: (id: string) => void;
  title?: string;
  noBoarder?: boolean;
  isLandlordCopy?: boolean;
  setCurrentSelectedDocumentVersion?: React.Dispatch<React.SetStateAction<string | null>>
}> = (props) => {
  const currentDocument = !props.isLandlordCopy
    ? props.currentFile?.document?.draftDocument
    : props.currentFile?.seperateDocumentForLandlord?.draftDocument;

  return (
    <>
      <div
        className={`bg-white ${
          props.noBoarder ? "" : "border"
        } rounded-sm signed-time-wrap`}
      >
        <div className="px-4 py-3">
          <div className="row no-gutters">
            <div className="col-md-6 col-12 ">
              <div className="d-flex align-items-center">
                <div>
                  {" "}
                  <h5 className="font-normal font-sm font-weight-semibold mb-0">
                    {props.title}
                  </h5>
                </div>
                {!!props.versions?.length && (
                  <div
                    className="document-dropdown pl-2"
                    style={{ width: "118px" }}
                  >
                    <VersionAutoCompleteInput
                      defaultValue={props.currentFile}
                      placeholder={"Version"}
                      onChange={(val: any) => {
                        props.changeDocument(val._id);
                      }}
                      list={props.versions}
                    />
                  </div>
                )}
              </div>

              <span
                className="d-block mt-2 font-xs text-gray-500 font-weight-semibold"
                style={{ textTransform: "none" }}
              >
                Created By{" "}
                <span className="text-dark">
                  {props.currentFile?.document?.uploadedBy?.name}
                </span>{" "}
                on{" "}
                <span className="text-dark">
                  {" "}
                  {moment(props.currentFile?.createdAt).format(
                    "DD MMM YYYY hh:mm A"
                  )}
                </span>
              </span>
            </div>
            <div className="col-md-6 col-12 align-items-center d-md-flex mt-3 mt-md-0 justify-content-end">
              <ul
                className="list-unstyled d-flex border-right border font-weight-semibold"
                style={{ backgroundColor: "#f4f3fa" }}
              >
                {/* <li
                  className="px-2 font-xs border-right d-flex align-items-center py-1 cursor-pointer"
                  style={{ lineHeight: "inherit" }}
                  onClick={() => {
                    // props.setResolveDocuments();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="mr-2"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M9.75 1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V6.75L9.75 1.5Z"
                      stroke="#3F4241"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.75 1.5V6.75H15"
                      stroke="#3F4241"
                      stroke-width="1.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>{" "}
                  Docx Download
                </li> */}

                <li
                  className="px-2 font-xs d-flex align-items-center py-1 cursor-pointer"
                  style={{ lineHeight: "inherit" }}
                  onClick={props.onEdit}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    className="mr-2"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M11.4961 1.99955C11.6712 1.82445 11.8791 1.68556 12.1078 1.5908C12.3366 1.49604 12.5818 1.44727 12.8294 1.44727C13.0771 1.44727 13.3222 1.49604 13.551 1.5908C13.7798 1.68556 13.9877 1.82445 14.1628 1.99955C14.3379 2.17465 14.4768 2.38252 14.5715 2.61129C14.6663 2.84006 14.715 3.08526 14.715 3.33288C14.715 3.58051 14.6663 3.8257 14.5715 4.05448C14.4768 4.28325 14.3379 4.49112 14.1628 4.66622L5.16276 13.6662L1.49609 14.6662L2.49609 10.9996L11.4961 1.99955Z"
                      stroke="#3F4241"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Edit
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-4">
            <PDFViewer
              pdfUrl={
                !props.isLandlordCopy
                  ? currentDocument?.location!
                  : currentDocument?.location!
              }
              file={currentDocument}
            ></PDFViewer>
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentView;
